import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';
import { TopLoaderProvider } from "./context/TopLoaderContext";

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
     <TopLoaderProvider>
      <App />
     </TopLoaderProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
